import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/profile';
import { Profile } from '@rootCommon/types/profile';
import { ResultState } from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
export type ProfileState = ResultState<Profile | null>;

const initialState: ProfileState = {
  data: null,
  loading: false,
  error: null,
};

export const profileReducer = (state = initialState, action: Action): ProfileState => {
  switch (action.type) {
    case getType(actions.fetchProfile.request):
      return { ...state, loading: true };
    case getType(actions.fetchProfile.success):
      return {
        ...state, loading: false, error: null, data: action.payload,
      };
    case getType(actions.fetchProfile.failure):
      return { ...state, loading: false, error: action.payload };

    case getType(actions.updateProfile.request):
      return { ...state, loading: true };
    case getType(actions.updateProfile.success):
      return {
        ...state, loading: false, error: null, data: action.payload,
      };
    case getType(actions.updateProfile.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default profileReducer;
